import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import styles from "./ASPricing.module.css";
import Nav from "../../components/Nav/Nav";
import PricingOptionWide from "../../components/PricingOptionWide/PricingOptionWide";
import Footer from "../../components/Footer/Footer";
import { StaticRoutes } from "../routes";
import AttentionModal from "../../components/Pricing/AttentionModal/AttentionModal";
import SignupErrorMessage from "../../components/SignupErrorMessage/SignupErrorMessage";

const ASPricing = ({
  airline,
  navList = [
    {
      label: "HOME",
      options: [],
      border: false,
      path: StaticRoutes.Home,
    },
    {
      label: "PRODUCTS",
      options: [
        { label: "BIDDING", path: StaticRoutes.Bidding },
        { label: "TRIPBOARD", path: StaticRoutes.TripBoard },
        { label: "SENIORITY", path: StaticRoutes.Seniority },
      ],
      border: false,
    },
    {
      label: "PRICING",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: false,
    },
    {
      label: "CONTACT US",
      options: [],
      border: false,
      path: StaticRoutes.Contact,
    },
    /*{
      label: "LOG IN",
      options: [],
      border: false,
      path: StaticRoutes.Login,
    },*/
    {
      label: "SIGN UP",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: true,
    },
  ],
  pricingOptions = [
    {
      packageName: "Bidding & Seniority",
      priceMonthly: "9.99",
      priceAnnual: "119.88",
      onMonthly: () => null,
      onAnnual: () => null,
      sections: [
        {
          section: {
            logo: "BidProPlusBiddingLogo.png",
            header: "Bidding",
            features: [
              {
                feature: "Download bid packages",
                isNew: "",
              },
              {
                feature: "Customize bidline colors & sorts",
                isNew: "",
              },
              {
                feature: "Search & prepare bids offline",
                isNew: "",
              },
              {
                feature: "Submit bids directly and skip PBSI",
                isNew: "",
              },
            ],
          },
        },
      ],
    },
  ],
  footerLists = [
    {
      header: "MENU",
      links: [
        { name: "Home", src: StaticRoutes.Home },
        { name: "Contact Us", src: StaticRoutes.Contact },
        { name: "Sign Up", src: StaticRoutes.Home },
      ],
    },
    {
      header: "PRODUCTS",
      links: [
        { name: "Bidding", src: StaticRoutes.Bidding },
        { name: "Trip Board", src: StaticRoutes.TripBoard },
        { name: "Seniority", src: StaticRoutes.Seniority },
        { name: "Pricing", src: StaticRoutes.UPSPricing },
      ],
    },
    {
      header: "TECH SUPPORT",
      links: [
        { name: "tech@bidpro.com", src: "mailto:tech@bidpro.com" },
        { name: "1-800-918-4980", src: "tel:18009184980" },
      ],
    },
  ],
}) => {
  const [animate, setAnimate] = useState(false);
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showErrorComponent, setShowErrorComponent] = useState(false);

  const handleLoginClose = () => {
    setShowErrorComponent(true);
  };
  const handleSignUpClick = (packageName, cycle) => {
    setIsModalOpen(true);
  };

  useEffect(() => {
    setAnimate(true);
  }, []);

  const navListWithNavigate = navList.map((item) => ({
    ...item,
    onClick: () => navigate(item.path),
    options: item.options?.map((option) => ({
      ...option,
      onClick: () => navigate(option.path),
    })),
  }));

  return (
    <>
      <Nav isStatic={true} navItems={navListWithNavigate} />
      <div
        className={`${styles.pageContainer} ${animate ? styles.slideIn : ""}`}
      >
        {showErrorComponent ? (
          <SignupErrorMessage
            onBackToLogin={() => navigate("/login")}
            airline="UPS"
            position="login"
          />
        ) : (
          <>
            <h2 className={styles.h2}>Subscribe to BidPro</h2>
            <div>
              {pricingOptions.map((option, index) => (
                <div className={styles.col} key={index}>
                  <PricingOptionWide
                    {...option}
                    onMonthly={() =>
                      handleSignUpClick(option.packageName, "monthly")
                    }
                    onAnnual={() =>
                      handleSignUpClick(option.packageName, "annual")
                    }
                  />
                </div>
              ))}
            </div>
          </>
        )}
      </div>
      <Footer lists={footerLists} inverse={true} />
      {isModalOpen && (
        <AttentionModal
          isOpen={isModalOpen} /*!isLoading && isModalOpen*/
          onCloseButtonClick={() => {
            setIsModalOpen(false);
            handleLoginClose();
          }}
          airline="ALASKA"
        />
      )}
    </>
  );
};

ASPricing.propTypes = {
  navList: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      options: PropTypes.array,
      border: PropTypes.bool,
      onClick: PropTypes.func.isRequired,
    })
  ),
  pricingOptions: PropTypes.arrayOf(
    PropTypes.shape({
      packageName: PropTypes.string.isRequired,
      priceMonthly: PropTypes.string.isRequired,
      priceAnnual: PropTypes.string.isRequired,
      onMonthly: PropTypes.func.isRequired,
      onAnnual: PropTypes.func.isRequired,
      sections: PropTypes.arrayOf(
        PropTypes.shape({
          section: PropTypes.shape({
            logo: PropTypes.string,
            header: PropTypes.string,
            features: PropTypes.arrayOf(
              PropTypes.shape({
                feature: PropTypes.string,
                isNew: PropTypes.string,
              })
            ),
          }),
        })
      ),
    })
  ),
  footerLists: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string,
      links: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          src: PropTypes.string,
        })
      ),
    })
  ),
};

export default ASPricing;
